import { ComplianceProgramCalibrationType } from "types/graphql-schema";

// Hides the tab for every organization until its release.
export const CALIBRATION_TAB_FLAG = "calibration-tab";

/**
 * The Calibration tab shows on a review that calibrates and links a talent
 * indicator set, while the calibration-tab flag is on. A cheap check: the tab
 * itself says so when every talent indicator is hidden or asked only in the
 * self review.
 */
export const hasCalibrationTab = (complianceProgram: {
  calibration: ComplianceProgramCalibrationType;
  performanceAssessmentTemplate?: {
    questionSetLinks: readonly {
      isTalentIndicators: boolean;
      removed: boolean;
    }[];
  } | null;
}) =>
  waffle.flag_is_active(CALIBRATION_TAB_FLAG) &&
  complianceProgram.calibration !== ComplianceProgramCalibrationType.Off &&
  (
    complianceProgram.performanceAssessmentTemplate?.questionSetLinks ?? []
  ).some((link) => link.isTalentIndicators && !link.removed);

/**
 * The tab strip is the only list of tabs a person may open, so a URL naming
 * one that is not on it falls back to the first tab they do have. The
 * Reporting tabs (Results, Calibration, engagement Results) share one type,
 * so they must match on the report tab too.
 */
export const getVisibleTab = <Tab extends { type: string; reportTab?: string }>(
  tabOptions: readonly { value: Tab }[],
  selectedTab: Tab,
): Tab => {
  if (tabOptions.length === 0) {
    return selectedTab;
  }
  const allowed = tabOptions.some(
    ({ value }) =>
      value.type === selectedTab.type &&
      value.reportTab === selectedTab.reportTab,
  );
  return allowed ? selectedTab : tabOptions[0].value;
};
